// extracted by mini-css-extract-plugin
export default {"auth-cont":"Auth_auth-cont__CA6rJ","auth-by":"Auth_auth-by__KwHmI","name":"Auth_name__vm7sx"};